import { cn } from "src/lib/utils";

interface TrueFalseButtonsProps {
  value: boolean | null;
  onChange: (value: boolean) => void;
}

export function TrueFalseButtons({ value, onChange }: TrueFalseButtonsProps) {
  const choices = [
    { label: "True", pressed: true },
    { label: "False", pressed: false },
  ];

  return (
    <div className="grid grid-cols-2 gap-3">
      {choices.map((choice) => {
        const selected = value === choice.pressed;
        return (
          <button
            key={choice.label}
            type="button"
            aria-pressed={selected}
            onClick={() => onChange(choice.pressed)}
            className={cn(
              "rounded-xl border px-4 py-4 font-roboto text-lg font-semibold",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
              selected ? "border-rfpurple-600 bg-rfpurple-50 text-[#3e1168]" : "border-rfpurple-200 bg-white text-[#3e1168]"
            )}
          >
            {choice.label}
          </button>
        );
      })}
    </div>
  );
}

export default TrueFalseButtons;
